// import gsap from '/assets/js/lib/gsap/gsap.min.js'
// import ScrollTrigger from '/assets/js/lib/gsap/ScrollTrigger.min.js'
// import ScrollToPlugin from '/assets/js/lib/gsap/ScrollToPlugin.min.js'
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export class ClassSwiperPeople {
  constructor(_target) {
    // this.target = _target;
    this.mySwiper;

    this.firstFlag = false;

    this.targetSwiperContainer = _target.querySelector(".swiper-container");
    this.targetSwiperWrapper = _target.querySelector(".swiper-wrapper");
    this.slideItems = _target.querySelectorAll(".swiper-slide");
    this.targetBtnNext = _target.querySelector(".swiper-button-next");
    this.targetBtnPrev = _target.querySelector(".swiper-button-prev");
    this.targetPagination = _target.querySelector(".swiper-pagination");

    this.slideLen = this.slideItems.length;
    // console.log("slideItemsW" + this.slideItemsW)
    // console.log("ALL" + this.targetSwiperWrapper.offsetWidth)
    this.excute();
  }

  swiperExcute() {
    const _this = this;

    _this.firstFlag = false;

    if (this.mySwiper != undefined) {
      this.mySwiper.destroy();
      this.mySwiper = undefined;
    }

    const swiper = this.mySwiper;

    this.mySwiper = new Swiper(this.targetSwiperContainer, {
      navigation: {
        nextEl: _this.targetBtnNext,
        prevEl: _this.targetBtnPrev,
      },
      pagination: {
        el: _this.targetPagination,
        type: "custom",
        renderCustom: function (swiper, current, total) {
          return `<span class="swiper-pagination__current">${current}</span><span class="swiper-pagination__line">/</span><span class="swiper-pagination__total">${total}</span>`;
        },
      },
      speed: 700,
      updateOnMove: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      effect: "slide",
      loop: true,
      // initialSlide: initialSlideVal,
      initialSlide: _this.slideLen,
      loopAdditionalSlides: 1,
      slidesPerView: "auto",
      spaceBetween: 0, //15
      centeredSlides: false,
      breakpoints: {
        1024: { // PC幅
          allowTouchMove: false,
        }
      },
      on: {
        init: function () {
          if (_this.activeSlide) {
            _this.oldSlide = _this.activeSlide;
            setTimeout(function () {
              _this.oldSlide.classList.remove("is-animate");
            }, 50);
          }
          _this.activeSlide = this.slides[this.activeIndex];
          setTimeout(function () {
            _this.activeSlide.classList.add("is-animate");
          }, 100);
        },
        realIndexChange: function (e) {
          if (_this.activeSlide) {
            _this.oldSlide = _this.activeSlide;
            setTimeout(function () {
              _this.oldSlide.classList.remove("is-animate");
            }, 50);
          }
          _this.activeSlide = this.slides[this.activeIndex];
          setTimeout(function () {
            _this.activeSlide.classList.add("is-animate");
          }, 100);
        },
      },
    });
    this.mySwiper.autoplay.stop();

    ScrollTrigger.create({
      trigger: _this.targetSwiperContainer,
      start: "0 100%",
      markers: false,
      onEnter: () => {
        // motionElem.classList.add('is-motion')
        if (_this.firstFlag == false) {
          // console.log("play")
          _this.firstFlag = true;
          _this.mySwiper.autoplay.start();
        }
      },
    });
  }

  funcResize() {
    if (window.innerWidth < 1024) {
      this.mode = "SP";
    } else {
      this.mode = "PC";
    }
    if (this.mode != this.oldMode) {
      this.swiperExcute();
    }
    this.oldMode = this.mode;
  }

  excute() {
    const _this = this;
    window.addEventListener("resize", function () {
      clearTimeout(_this.timeoutId);
      _this.timeoutId = setTimeout(function () {
        _this.funcResize();
      }, 100);
    });
    this.funcResize();
  }

  play() {
    // if(this.state == "play") this.mySwiper.autoplay.start()
  }

  motionToggle(_state) {
    if (_state == "stop") {
      this.state = "stop";
      this.mySwiper.autoplay.stop();
    }
    if (_state == "play") {
      this.state = "play";
      this.mySwiper.autoplay.start();
    }
  }
}
